import { LoadingSplashScreenModule } from './loading-splash-screen/loadin-splash-screen.module';
import { LoadingSplashScreenComponent } from './loading-splash-screen/loading-splash-screen.component';
import { AuthCookieService } from './auth/auth-cookie.service';

import { RootStoreModule } from './root-store/root-store.module';
import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppRoutingModule } from './app-routing.module';
import { EntityDataModule } from '@ngrx/data';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { PortalMockBackendModule } from '@portal-front-end/mock-backend';
import { environment } from '../environments/environment';
import { API_SERVER_TOKEN, AUTH_SERVER_TOKEN } from '@portal-front-end/api';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { AuthStoreInterceptor } from './auth/auth-store.interceptor';
import { ServiceWorkerModule } from '@angular/service-worker';
import { MAT_DATE_LOCALE } from '@angular/material/core';
import { MAT_MOMENT_DATE_ADAPTER_OPTIONS } from '@angular/material-moment-adapter';
import { MatSnackBarModule } from '@angular/material/snack-bar';
@NgModule({
  declarations: [
    AppComponent,
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    AppRoutingModule,
    RootStoreModule,
    EntityDataModule,
    PortalMockBackendModule,
    FontAwesomeModule,
    LoadingSplashScreenModule,
    MatSnackBarModule,
    ServiceWorkerModule.register('ngsw-worker.js', { enabled: environment.production }),
  ],
  providers: [
    AuthCookieService,
    { provide: API_SERVER_TOKEN, useValue: environment.apiServer },
    { provide: AUTH_SERVER_TOKEN, useValue: environment.authenticationServer },
    { provide: HTTP_INTERCEPTORS, useClass: AuthStoreInterceptor, multi: true },
    { provide: MAT_DATE_LOCALE, useValue: 'en-AU' },
    { provide: MAT_MOMENT_DATE_ADAPTER_OPTIONS, useValue: {useUtc: true}}
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
